import { PlayCircle } from 'lucide-react'
import { Box, Button, Stack, Typography } from '@mui/material'
import { useOnboarding } from '../../context/OnboardingContext'
import { BodyText, StepCard } from '../../components/ui'
import { SUPPORT_EMAIL } from '../../data/mockSeed'
import { MISC_NAVY } from '../../theme/onboardingTheme'

/** Design manual p.1 — Welcome. */
export function StepWelcome() {
  const { advance } = useOnboarding()

  return (
    <StepCard>
      <Typography component="h3" sx={{ fontSize: { xs: '1.25rem', sm: '1.5rem' }, fontWeight: 600, color: '#0f172a' }}>
        Welcome to MISC
      </Typography>
      <Stack spacing={2.5} sx={{ mt: 2 }}>
        <BodyText>
          We are pleased to welcome you as a partner and appreciate your trust in MISC to manage your Surplus Lines Tax
          Filings.
        </BodyText>
        <BodyText>
          You now have a team of experts behind you, people who genuinely care about accuracy, timelines, and making your
          life easier.
        </BodyText>

        <Box
          role="img"
          aria-label="Onboarding video tutorial (placeholder)"
          sx={{
            display: 'grid',
            placeItems: 'center',
            aspectRatio: '16 / 9',
            maxHeight: 360,
            borderRadius: 2,
            bgcolor: MISC_NAVY,
            color: 'rgba(255,255,255,0.85)',
          }}
        >
          <Box sx={{ textAlign: 'center' }}>
            <PlayCircle size={56} aria-hidden />
            <Typography sx={{ mt: 1, fontSize: 14 }}>Onboarding video tutorial (placeholder)</Typography>
          </Box>
        </Box>

        <Box>
          <Typography sx={{ fontWeight: 600, color: '#0f172a' }}>Here&apos;s What Happens Next</Typography>
          <Box component="ul" sx={{ mt: 1, mb: 0, pl: 2.5, fontSize: { xs: 14, sm: 15 }, lineHeight: 1.7, color: '#1e293b' }}>
            <li>Onboarding instructions and a video tutorial will guide you through each step.</li>
            <li>We will provide a checklist of documents and information required to set up your account.</li>
            <li>You will receive access to our tools, resources, and support team.</li>
          </Box>
        </Box>
        <BodyText>We are here to make compliance simple, predictable, and stress-free.</BodyText>
        <BodyText sx={{ fontWeight: 600, color: '#0f172a' }}>Welcome. We&apos;re excited to get started with you.</BodyText>

        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, pt: 1 }}>
          <Button type="button" variant="contained" onClick={advance}>
            Start Onboarding
          </Button>
          <Button type="button" variant="outlined" href={`mailto:${SUPPORT_EMAIL}`}>
            Contact Support
          </Button>
        </Box>
      </Stack>
    </StepCard>
  )
}
